'use strict';
ui.loadTemplateFile('characterstatus.html');

class CharacterStatusDialog extends Dialog {
  _element: any;
  _titleBar: any;
  name: any;
  hp: any;
  mp: any;
  xp: any;
  fuel: any;
  _data: any;

  constructor(character: any) {
    super('characterstatus.html');

    this.name = ui.label(this, '.label.name');
    this.hp = ui.progressbar(this, '.progressbar.health');
    this.mp = ui.progressbar(this, '.progressbar.mana');
    this.xp = ui.progressbar(this, '.progressbar.exp');
    this.fuel = ui.progressbar(this, '.progressbar.fuel');

    this._data = character;
    this._data.on('changed', this._update.bind(this));
    this._data.inventory.on('changed', this._update.bind(this));
    this._update();
  }

  _update() {
    this.name.text(this._data.name);

    const maxHp = this._data.calculatedStats?.maxHp || this._data.stats.getMaxHp();
    this.hp.max(maxHp);
    this.hp.value(Math.min(this._data.hp, maxHp));

    this.mp.max(this._data.stats.getMaxMp());
    this.mp.value(this._data.mp);

    this.xp.max(this._data.stats.getNeedRawExp());
    this.xp.value(this._data.xp);

    const driving = !!this._data.isDriving;
    this._element.find('.fuel-display').css('display', driving ? 'flex' : 'none');
    if (driving) {
      const engine = this._data.inventory.findBySlot(136);
      this.fuel.value(Math.max(0, Math.min(100, engine?.itemLife || 0)));
    }

    const jobs: {[key: number]: string} = {
      0: 'Visitor', 111: 'Soldier', 121: 'Knight', 122: 'Champion',
      211: 'Muse', 221: 'Mage', 222: 'Cleric', 311: 'Hawker',
      321: 'Raider', 322: 'Scout', 411: 'Dealer', 421: 'Bourgeois', 422: 'Artisan',
    };
    this._element.find('.character-details .level').text(this._data.level);
    this._element.find('.character-details .class-name').text(jobs[this._data.job] || String(this._data.job));
    this._element.find('.character-details .weight').text('Weight: ' + (this._data.weightRate || 0) + '%');
  }
}

ui.CharacterStatusDialog = CharacterStatusDialog;
ui.characterStatusDialog = (character: any) => {
  return new ui.CharacterStatusDialog(character);
};
